import React from 'react';
import '../CSS/QuemsomosAboutus.css';
import backgroundImage from '../Images/fundo2.png';
import backgroundImageWebp from '../Images/fundo2.webp';

const Politics = () => {
  return (
    <div>
      <picture>
        <source srcSet={backgroundImageWebp} type="image/webp" />
        <img src={backgroundImage} className="backImage2" alt="" loading="eager" decoding="async" />
      </picture>

      <div className="er-pageShell">
        <div className="divCenteredContent er-container">
          <div className="divBigTitle">
            <h1 className="BigTitle">Cookie Policy</h1>
          </div>

          <p className="regularTextYellow">1. What Are Cookies</p>
          <p className="regularText">
            Cookies are small text files stored on the user’s device when visiting a website. They help improve the browsing experience
            and allow the collection of statistical information.
          </p>

          <p className="regularTextYellow">2. Types of Cookies Used</p>
          <p className="regularText">This website may use the following types of cookies:</p>

          <p className="regularTextYellow">a) Strictly Necessary Cookies</p>
          <p className="regularText">
            These cookies are essential for the proper functioning of the website and to enable basic features such as navigation and
            access to secure areas.
          </p>
          <p className="regularText">These cookies do not require user consent.</p>

          <p className="regularTextYellow">b) Analytical / Statistical Cookies</p>
          <p className="regularText">
            These cookies are used to collect aggregated and anonymous statistical data about website usage, helping us improve our
            services and user experience.
          </p>
          <p className="regularText">These cookies are only used with the user’s explicit consent.</p>

          <p className="regularTextYellow">3. Cookie Management</p>
          <p className="regularText">Users may, at any time:</p>
          <p className="regularText">- Accept or reject non-essential cookies through the cookie banner</p>
          <p className="regularText">- Configure their browser settings to block or delete cookies</p>
          <p className="regularText">Please note that disabling cookies may affect certain website functionalities.</p>

          <p className="regularTextYellow">4. Third-Party Cookies</p>
          <p className="regularText">
            The website may use third-party services for statistical or analytical purposes. These third parties process data in
            accordance with their own privacy and cookie policies.
          </p>

          <p className="regularTextYellow">5. Changes to This Cookie Policy</p>
          <p className="regularText">
            This Cookie Policy may be updated at any time. Any changes will be published on this website and take effect upon
            publication.
          </p>

          <p className="regularTextYellow">6. Contact Information</p>
          <p className="regularText">
            For more information regarding the use of cookies, please contact us at:{' '}
            <a className="regularText" href="mailto:be.escaperoom@gmail.com">be.escaperoom@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Politics;

